import React from "react";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaViber } from "react-icons/fa";

interface ShareToSocialProps {
  url: string;
  title: string;
  onClose?: () => void;
}

const ShareToSocial: React.FC<ShareToSocialProps> = ({ url, title, onClose }) => {
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  const platforms = [
    {
      name: "Facebook",
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      icon: <FaFacebookF />,
      bgColor: "bg-blue-600",
    },
    {
      name: "Twitter",
      url: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
      icon: <FaTwitter />,
      bgColor: "bg-sky-500",
    },
    {
      name: "LinkedIn",
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      icon: <FaLinkedinIn />,
      bgColor: "bg-blue-700",
    },
    {
      name: "Viber",
      url: `viber://forward?text=${encodedTitle}%20${encodedUrl}`,
      icon: <FaViber />,
      bgColor: "bg-purple-600",
    },
  ];

  const openPopup = (shareUrl: string) => {
    const popup = window.open(
      shareUrl,
      "_blank",
      "width=600,height=400,scrollbars=no,resizable=no"
    );

    // Some mobile browsers block popups → fallback open in same tab
    if (!popup) {
      window.location.href = shareUrl;
    }

    if (onClose) onClose();
  };

  return (
    <div className="flex justify-center items-center gap-3 w-full pb-2">
      {platforms.map((platform) => (
        <button
          key={platform.name}
          onClick={() => openPopup(platform.url)}
          className={`text-white flex justify-center hover:scale-110 items-center p-1 h-6 w-6 rounded-full ${platform.bgColor} hover:opacity-90`}
          title={`Share on ${platform.name}`}
        >
          {platform.icon}
        </button>
      ))}
    </div>
  );
};

export default ShareToSocial;



